import {injectionSignals,redactSecrets} from './security-policy';

// Public citations only; never reuse this to grant access to an app route.
export function publicSearchHref(value:string):string|null {
 try {
  const u=new URL(value);
  if(!['https:','http:'].includes(u.protocol)||u.username||u.password||u.port)return null;
  const host=u.hostname.toLowerCase();
  if(!/^[a-z0-9.-]+\.[a-z]{2,}$/.test(host)||/(?:^|\.)(?:localhost|local|internal|invalid|test|lan|home|onion)$/.test(host)||host.endsWith('.ts.net'))return null;
  if(value.length>2000||redactSecrets(value)!==value)return null;
  u.hash='';return u.href;
 } catch{return null;}
}
export function validatePublicQuery(value:unknown):string {
 if(typeof value!=='string')throw new Error('Enter a public web search query.');
 const q=value.trim().replace(/\s+/g,' ');
 if(q.length<3||q.length>200||injectionSignals(q).length||redactSecrets(q)!==q||
 /@|https?:|www\.|[\\/<>{}\[\]]|\b[0-9a-f]{8}-[0-9a-f-]{27,}\b|(?:\d[ ()+.-]*){7,}|\b(?:password|api.key|token|medical|diagnosis|payslip)\b/i.test(q))throw new Error('Search public topics only; do not include private records, contact details or credentials.');
 return q;
}
export function cleanSearchText(value:unknown,max:number):string {
 return typeof value==='string'?value.replace(/<[^>]*>/g,' ').replace(/\s+/g,' ').trim().slice(0,max):'';
}
